export default class ExportSetController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/exportSet/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/delete', 'post', params, axiosOption, httpOption);
  }
  static listDict (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportSet/listDict', 'get', params, axiosOption, httpOption);
  }
}
